<template>
    <v-expansion-panel v-bind="$attrs" v-model="panel">
      <v-expansion-panel-header class="mt-2" @click.native="loadDashboardData()"> Dashboard
        <template v-slot:actions>
          <v-btn @click.native.stop="forcesUpdate()" icon small>
              <v-icon color="primary">mdi-reload</v-icon>
          </v-btn>
          <!-- <v-icon color="primary" @click.native="forcesUpdate()">mdi-chevron-down</v-icon> -->
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <template v-if="shouldRenderDashboard">
          <!--     <v-row class="number-statistics mb-2 mt-0" #align-content-md>
            <div class="text-center">Ultimos 7 dias estadisticas</div>
          </v-row> -->
          <v-row class="my-3 mx-3">
            <v-col cols="12">
              <div class="box shadow pa-2" style="border: none;">
                <div class="row justify-center text-center">
                  <div class="col-12 mt-3 mb-2" style="font-weight: bold; font-size: 12pt;">
                    {{ userInfo?.business }}
                  </div>
                  <div class="col-12 mb-3">
                  Actualmente se esta monstrando informacion de <b>{{ selectedBranchName }}</b> <v-icon color="primary" style="cursor: pointer; margin-left: 6px;" @click="showBanches = !showBanches" v-if="this.$store.getters['rolesUser/getArrayCustomRole']([277])">{{showBanches ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
                  </div>
                  <div class="col-4" v-if="showBanches && this.$store.getters['rolesUser/getArrayCustomRole']([277])">
                    <v-select 
                      outlined
                      dense
                      v-model="branchSelected"
                      :items="branches"
                      @change="setBranchChange()"
                      attach
                      item-value="ID_Branch"
                      item-text="BranchName"
                      label="Sucursal"
                    />
                  </div>
                </div>
                </div>
            </v-col>
          </v-row>
          <v-row class="number-statistics mx-3">
            <v-col cols="12" sm="12" md="6" lg="3" class="mb-3" v-if="$store.getters['rolesUser/getCustomRole'](54)">
              <div class="box pa-3 shadow p-3">
                <div class="d-flex align-center justify-space-between">
                  <div class="warning c-icon">
                    <v-icon class="white--text">mdi-account-multiple</v-icon>
                  </div>
                  <div class="text-right">
                    <h5>Total Clientes</h5>
                    <spinner v-if="loadLineData" height="20px" :size="22" :width="2"/>
                    <span v-else>
                      {{ lineData.customersTotal }}
                    </span>
                  </div>
                </div>
              </div>
            </v-col>

            <v-col cols="12" sm="12" md="6" lg="3" class="mb-3" v-if="$store.getters['rolesUser/getCustomRole'](55)">
              <div class="box pa-3 shadow p-3">
                <div class="d-flex justify-space-between">
                  <div class="c-icon success">
                    <v-icon class="white--text">mdi-cash-multiple</v-icon>
                  </div>
                  <div class="text-right">
                    <h5>7 dias Facturación</h5>
                    <spinner v-if="loadLineData" height="20px" :size="22" :width="2"/>
                    <span v-else>
                      <div title="Ventas totales sin IVA">
                        ${{ lineData.salesAmount }}
                      </div>
                      <div title="Ventas totales con IVA">
                        <small>${{ lineData.salesAmountWIVA }}</small>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </v-col>

            <v-col cols="12" sm="12" md="6" lg="3" class="mb-3" v-if="$store.getters['rolesUser/getCustomRole'](56)">
              <div class="box pa-3 shadow p-3">
                <div class="d-flex justify-space-between">
                  <div class="warning c-icon">
                    <v-icon class="white--text">mdi-account-multiple</v-icon>
                  </div>
                  <div class="text-right">
                    <h5>Nuevos clientes 7 dias</h5>
                    <spinner v-if="loadLineData" height="20px" :size="22" :width="2"/>
                    <span v-else>
                      {{ lineData.customers }}
                    </span>
                  </div>
                </div>
              </div>
            </v-col>

            <v-col cols="12" sm="12" md="6" lg="3" class="mb-3" v-if="$store.getters['rolesUser/getCustomRole'](57)">
              <div class="box pa-3 shadow p-3">
                <div class="d-flex justify-space-between">
                  <div class="c-icon success">
                    <v-icon class="white--text" @click="getLineData">mdi-cash-multiple</v-icon>
                  </div>
                  <div class="text-right">
                    <h5>Mes Facturación</h5>
                    <spinner v-if="loadLineData" height="20px" :size="22" :width="2"/>
                    <span v-else>
                      <div title="Ventas totales sin IVA">
                        ${{ lineData.salesTotal }}
                      </div>
                      <div title="Ventas totales con IVA">
                        <small>${{ lineData.salesTotalWIVA }}</small>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="businessType != 'accounting_and_bill' && ($store.getters['rolesUser/getCustomRole'](58))" cols="12" md="6" lg="6" class="mb-3">
              <div class="box pa-3 shadow p-3">
                <div class="d-flex justify-space-between">
                  <div class="warning c-icon">
                    <v-icon class="white--text">mdi-account-multiple</v-icon>
                  </div>
                  <div class="text-right">
                    <h5>Total de pacientes</h5>
                    {{ lineData.totalPatients }}
                  </div>
                </div>
              </div>
            </v-col>
            <v-col v-if="businessType != 'accounting_and_bill' && ($store.getters['rolesUser/getCustomRole'](59))" cols="12" :md="businessType != 'accounting_and_bill' ? 6 : 12" lg="6" class="mb-3">
              <div class="box pa-3 shadow p-3">
                <div class="d-flex justify-space-between">
                  <div class="warning c-icon">
                    <v-icon class="white--text">mdi-account-multiple</v-icon>
                  </div>
                  <div class="text-right">
                    <h5>Pacientes en los últimos 7 días</h5>
                    {{ lineData.patients7Days }}
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row style="margin-left: 0.5rem; margin-right: 0.5rem">
            <template v-if="businessType == 'bloodtestlaboratory'">
              <v-col cols="12"  sm="12"  md="6" lg="6" xl="6" class="mb-3"  v-if="$store.getters['rolesUser/getCustomRole'](63)">
                <div class="box box-m">
                  <ChartLine ref="chartLineRef" :key="chartLine" :branch="branchSelected" :ambiente="getAmbiente" :auto-load="false" />
                </div>
              </v-col>

              <v-col cols="12"  sm="12" md="6" lg="6" xl="6" class="mb-3" v-if="$store.getters['rolesUser/getCustomRole'](64)">
                <div class="box box-sm">
                  <ChartLineWeek ref="chartLineWeekRef" :key="chartLineWeek" :branch="branchSelected" :ambiente="getAmbiente" :auto-load="false" />
                </div>
              </v-col>
              <v-col cols="12"  sm="12" md="6" lg="6" xl="6" class="mb-3" v-if="$store.getters['rolesUser/getCustomRole'](66)">
                <div class="box">
                  <TopProductChart ref="topProductChartRef" :key="topProductChart" :branch="branchSelected" :ambiente="getAmbiente" :auto-load="false" />
                </div>
              </v-col>
            </template>
            <template v-else>
              <!--v-col cols="12"  sm="12" md="12" lg="12" xl="12" class="mb-3" v-if="businessType != 'accounting_and_bill' && ($store.getters['rolesUser/getCustomRole'](60))">
                <div class="box" style="height: 100%">
                  <PatientChart  :key="patientChart" />
                </div>
              </v-col-->
              <v-col
                cols="12"
                class="mb-3"
                v-if="businessType == 'accounting_and_bill' && $store.getters['rolesUser/getCustomRole'](248)"
              >
                <TaxDeclarationSummary
                  ref="taxDeclarationSummary"
                  :business-id="userInfo.businessid"
                  :refresh-token="taxSummaryRefreshToken"
                  :business-label="userInfo.business"
                  :auto-load="false"
                />
              </v-col>
              <v-col cols="12"  sm="12" md="6" lg="6" xl="6" class="mb-3" v-if="$store.getters['rolesUser/getCustomRole'](61)">
                <div class="box" style="height: 100%">
                  <Doghnut ref="doghnutChart" key="donnut-01" :branch="branchSelected" :ambiente="getAmbiente" :auto-load="false" />
                </div>
              </v-col>
              <v-col cols="12"  sm="12" md="6" lg="6" xl="6" class="mb-3" v-if="$store.getters['rolesUser/getCustomRole'](65)">
                <div class="box" style="height: 100%">
                  <TopProductChart ref="topProductChartRef" :key="topProductChart" :branch="branchSelected" :ambiente="getAmbiente" :auto-load="false"></TopProductChart>
                </div>
              </v-col>
               <v-col cols="12" class="mb-3" v-if="$store.getters['rolesUser/getCustomRole'](64)">
                <div class="box box-sm" style="height: 100%"> 
                  <ChartLineWeek ref="chartLineWeekRef" :key="chartLineWeek" :branch="branchSelected" :ambiente="getAmbiente" :auto-load="false" />
                </div>
              </v-col>
              <!--v-col cols="12"  sm="12" md="6" lg="6" xl="6" class="mb-3" v-if="$store.getters['rolesUser/getCustomRole'](62)">
                <div class="box" style="height: 100%">
                  <ChartProductsWarehouses />
                </div>
              </v-col-->
              <v-col cols="12"  sm="12" md="12" lg="12" xl="12" class="mb-3" v-if="$store.getters['rolesUser/getCustomRole'](63)">
                <div class="box box-m" style="height: 100%">
                  <ChartLine ref="chartLineRef" :key="chartLine" :branch="branchSelected" :ambiente="getAmbiente" :auto-load="false" />
                </div>
              </v-col>
            </template>
            <v-col cols="12"  sm="12" md="12" lg="12" xl="12" class="mb-3" v-if="$store.getters['rolesUser/getCustomRole'](66)">
              <div class="box" style="height: 97%" >
                <TopCustomerChart ref="topCustomerChartRef" :key="topCustomerChart" :branch="branchSelected" :ambiente="getAmbiente" :auto-load="false" />
              </div>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-content>
    </v-expansion-panel>
</template>
<script>
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

import TopCustomerChart from "../DashboardStats/TopCustomerChart.vue";
import TopProductChart from "../DashboardStats/TopProductChart.vue";
import Doghnut from "../DashboardStats/Doghnut.vue";
import TaxDeclarationSummary from "../DashboardStats/TaxDeclarationSummary.vue";
import ChartLine from "../DashboardStats/ChartLine.vue";
//import PatientChart from "../DashboardStats/PatientChart.vue";
//import ChartProductsWarehouses from "../DashboardStats/ChartProductsWarehouses.vue";
import /* DxDataGrid,
  DxColumn,
  DxScrolling,
  DxPaging, */
"devextreme-vue/data-grid";
import ChartLineWeek from "../DashboardStats/ChartLineWeek.vue";
import { mapState } from "vuex";
import spinner from "../DashboardStats/spinner.vue";
ChartJS.register(ArcElement, Tooltip, Legend);
export default {
  name: "Dashboard",
  components: {
    Doghnut,
    TaxDeclarationSummary,
    TopCustomerChart,
    ChartLine,
    TopProductChart,
    ChartLineWeek,
    //PatientChart,
    //ChartProductsWarehouses
    spinner,
  },
  data() {
    return {
      panel: 0,
      hasLoadedDashboard: false,
      showCustomer: false,
      businessType: "",
      topCustomers: [],
      topProducts: [],
      activeP: "dia",
      activeC: "dia",
      activePF: "Dias",
      patientChart: 0,
      chartLine: 0,
      topProductChart: 0,
      topCustomerChart: 0,

      lineData: {
        customersTotal: 0,
      },
      chartLineWeek: 0,
      countCustomers: [],
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      businesstype: JSON.parse(localStorage.getItem("user")).businesstype,
      userInfo: JSON.parse(localStorage.getItem("user")),
      branchSelected: this.userInfo?.branch ?? 0,
      branches: [],
      showBanches: false,
      role: JSON.parse(localStorage.getItem("user")).roles?.[0] || 'user',
      search: {},
      dataP: {
        labels: ["Actual", "Anterior", "Dos anteriores"],
        datasets: [
          {
            backgroundColor: ["#41B883", "#E9351", "#00D6FF"],
            data: [10, 10, 10],
          },
        ],
      },
      options: {
        responsive: false,
        width: "200px",
        heigth: "200px",
        maintainAspectRatio: false,
      },
      ambiente: JSON.parse(localStorage.getItem("branch"))?.AuthFeMode ?? 1,
      loadLineData: false,
      taxSummaryRefreshToken: 0,
      loadingDashboardInitialData: false,
    };
  },
  computed: {
    /*   isPanelOpened: function(){
          if (this.panel == 0){
          return  this.forcesUpdate()
          } else {
            return this.forcesUpdate()
          }
        } */
      
    ...mapState(
      "rolesUser",
      {
        rolesStatus: (state) => state.roles,
      }),
      isAdminOrManager() {
        const isAdminOrRoot = this.rolesStatus.some((role) => ['admin', 'root'].includes(role.RoleName));
        return isAdminOrRoot;
      },
      selectedBranchName(){
        const branch = this.branches.find(
          i => i.ID_Branch === this.branchSelected
        );
        return branch?.BranchName ?? '--';
      },
      getAmbiente(){
        const branch = this.branches.find(
          i => i.ID_Branch === this.branchSelected
        );
        console.log(branch?.AuthFeMode);
        
        return branch?.AuthFeMode ?? this.ambiente;
      },
      shouldRenderDashboard() {
        return this.hasLoadedDashboard;
      },

  
  },
  mounted() {
    this.getBusinessType();

    //this.getTopProducts();
    //this.getTopCustomers();
    /*    this.getCustomersDay(); */
  },
  watch: {
    panel(value) {
      if (value !== false && value !== null && value !== undefined) {
        this.loadDashboardData();
      }
    },
  },

  methods: {
    async loadDashboardData(forceRefresh = false) {
      if (this.loadingDashboardInitialData) {
        return;
      }

      if (this.hasLoadedDashboard && !forceRefresh) {
        return;
      }

      this.hasLoadedDashboard = true;
      this.loadingDashboardInitialData = true;

      if (forceRefresh) {
        this.patientChart += 1;
        this.chartLine += 1;
        this.chartLineWeek += 1;
        this.topProductChart += 1;
        this.topCustomerChart += 1;
      }

      await this.$nextTick();

      try {
        await this.getBranches();

        await Promise.allSettled([
          this.getLineData(),
          this.callDashboardRef("topCustomerChartRef", "getTopCustomers"),
        ]);

        await Promise.allSettled([
          this.callDashboardRef("doghnutChart", "getTopCustomersByDate"),
          this.callDashboardRef("chartLineWeekRef", "getTopProductsRange"),
        ]);

        await Promise.allSettled([
          this.callDashboardRef("chartLineRef", "loadInitialData"),
          this.callDashboardRef("topProductChartRef", "loadInitialData"),
        ]);

        await this.callDashboardRef("taxDeclarationSummary", "loadRecords");
      } finally {
        this.loadingDashboardInitialData = false;
      }
    },
    getDashboardRef(refName) {
      const ref = this.$refs[refName];
      return Array.isArray(ref) ? ref[0] : ref;
    },
    callDashboardRef(refName, methodName) {
      const ref = this.getDashboardRef(refName);

      if (!ref || typeof ref[methodName] !== "function") {
        return Promise.resolve();
      }

      return ref[methodName]();
    },
    setBranchChange(){
      if (!this.hasLoadedDashboard) {
        return;
      }

      this.getLineData();
      this.taxSummaryRefreshToken += 1;
    },
    getBranches() {
      return this.$API.branches
        .findBranches(JSON.parse(localStorage.getItem("user")).businessid)
        .then((data) => {
          this.branches = [
            {
              BranchName: 'Todas las sucursales',
              ID_Branch: 0
            },
            ...data
          ];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    forcesUpdate() {
      this.loadDashboardData(true);
    },
    /*getTopCustomers() {
      this.$API.dashboard.getTop().then((response) => {
        this.topCustomers = response;
        this.activeC = "dia";
      });
    },*/
    getBusinessType() {
      let user = JSON.parse(localStorage.getItem("user"))
      if (user && user.businesstype) {
        this.businessType = user.businesstype
      }
    },
    /*getTopCustomersw() {
      this.$API.dashboard.getTopCustomersw().then((response) => {
        this.topCustomers = response;
        this.activeC = "semana";
      });
    },*/
    /*getTopCustomersm() {
      this.$API.dashboard.getTopCustomersm().then((response) => {
        this.topCustomers = response;
        this.activeC = "mes";
      });
    },*/
    /*getTopCustomersy() {
      this.$API.dashboard.getTopCustomersy().then((response) => {
        this.topCustomers = response;
        this.activeC = "año(actual)";
      });
    },*/
    //pastel graphic
  /*   getCustomersYear() {
      this.$API.dashboard.CustomersYear().then((response) => {
        this.countCustomers = response;
        this.activePF = "años";
        this.dataP = {
          labels: ["Actual", "Anterior", "Dos anteriores"],
          datasets: [
            {
              backgroundColor: ["#41B883", "#E9351", "#00D6FF"],
              data: this.countCustomers,
            },
          ],
        };
      });
    }, */
    getCustomersMonth() {
      this.$API.dashboard.CustomersMonth().then((response) => {
        this.countCustomers = response;
        this.activePF = "meses";
        this.dataP = {
          labels: ["Actual", "Anterior", "Dos anteriores"],
          datasets: [
            {
              backgroundColor: ["#41B883", "#E9351", "#00D6FF"],
              data: this.countCustomers,
            },
          ],
        };
      });
    },
    /*getCustomersDay() {
      this.$API.dashboard.CustomersDay().then((response) => {
        this.countCustomers = response;
        this.dataP = {
          labels: ["Actual", "Anterior", "Dos anteriores"],
          datasets: [
            {
              backgroundColor: ["#41B883", "#E9351", "#00D6FF"],
              data: this.countCustomers,
            },
          ],
        };
        this.activePF = "dias";
      });
    },*/
    //end pastel graphic
    /*getTopProducts() {
      this.$API.dashboard.getProducts().then((response) => {
        this.topProducts = response;
        this.activeP = "dia";
      });
    },*/
    getLineData() {
      this.loadLineData = true;
      const params = {
        businessType: this.businessType,
        ambiente: this.ambiente,
        branch: this.branchSelected,
      }
      return this.$API.dashboard.getLineData(params).then((response) => {
        this.lineData = response;
        this.activeP = "dia";
      }).catch((err) => console.warn('/API getLineData',err))
      .finally(()=> this.loadLineData= false);
    },
    /*getTopProductsw() {
      this.$API.dashboard.getProductsw().then((response) => {
        this.topProducts = response;
        this.activeP = "Semana";
      });
    },*/
    /*getTopProductsm() {
      this.$API.dashboard.getProductsm().then((response) => {
        this.topProducts = response;
        this.activeP = "mes";
      });
    },*/
    /*getTopProductsy() {
      this.$API.dashboard.getProductsy().then((response) => {
        this.topProducts = response;
        this.activeP = "año(actual)";
      });
    },*/
  },
};
</script>
<style scoped>
.number-statistics .c-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 40px;
  border-radius: 8px;
}

.dx-theme-generic-typography h3 {
  color: #000000;
}

.table-statistics .purple {
  background-color: purple;
}

.table-statistics .orange {
  background-color: orange;
}

.table-statistics h4 {
  color: #fff;
  padding: 10px 20px;
}
.box {
  border-style: solid;
  border-color: black;
  border-width: 1px;
  background-color: white;
  padding: 0.5rem;
  border-radius: 15px;
  margin: 0.75rem;
  max-width: 100%;
  box-sizing: border-box; 
}

@media (min-width: 992px) {
  .box-m {
    height: 99%;
  }
  .box-sm {
    height: 98%;
  }
}
@media (max-width: 600px) {
  .box {
    padding: 0.5rem;
    margin: 0.5rem 0;
  }
}

</style>
